





















































































































import { Component, Vue, Prop } from 'vue-property-decorator'
import Search from '@/app/ui/components/Search/index'
import ModalAdd from './ModalAdd.vue'
import DeleteAll from '@/app/ui/components/ModalDeleteAll/index.vue'
import Delete from '@/app/ui/components/ModalDelete/index'
import { GalleryImageModule } from '@/app/store/modules/galleryImage'
import vueCustomScrollbar from 'vue-custom-scrollbar'

@Component({
  components: {
    vueCustomScrollbar,
    'modal-add': ModalAdd,
    search: Search,
    'delete-all': DeleteAll,
    delete: Delete,
  },
})
export default class extends Vue {
  public created() {
    this.getThumbnail()
  }
  public getThumbnail() {
    GalleryImageModule.getGalleryImageData()
  }
  private imageId: any = []
  public modalDelete: any = {
    idImage: 0,
    title: '',
  }
  public get thumbnailImageData(): any {
    const data = GalleryImageModule.galleryImageData.data || []
    return data.filter((e) => e.category.toLowerCase() === 'thumbnail')
  }
  private funcCancel(): any {
    this.imageId = []
  }
  private selectAll(): any {
    this.imageId = this.thumbnailImageData.map((item) => item.id)
  }
  private funcDelete(item, index, button): any {
    if (this.imageId.length === 0) {
      this.modalDelete.idImage = item.id
      this.modalDelete.title = item.name
      this.$root.$emit('bv::show::modal', 'deletethumbnail', button)
    }
  }
  private funcAdd(button): any {
    this.$root.$emit('bv::show::modal', 'addthumbnail', button)
  }
  public deleteNotif(): any {
    const ids = [this.modalDelete.idImage]
    GalleryImageModule.deleteGalleryImage({ ids })
    this.$root.$emit('bv::hide::modal', 'deletethumbnail')
  }

  public funcOke(item, index, button): any {
    const ids = this.imageId
    GalleryImageModule.deleteGalleryImage({ ids })
    this.$root.$emit('bv::hide::modal', 'deleteAllthumbnail', button)
    this.funcCancel()
  }

  public funcSearch(item) {
    GalleryImageModule.paginationParam.search = item
    GalleryImageModule.getGalleryImageData()
  }
  public get isDisabled() {
    return GalleryImageModule.isLoading
  }
}
